module.exports = __webpack_public_path__ + "static/media/dashboardBackground.58b9aa2b.jpg";